module.exports = __webpack_public_path__ + "static/media/gabriel_rojas.3581a754.jpg";